import { pushModalGuard, popModalGuard } from '@/utils/modalBackGuard';

/**
 * Mixin global (registrado en main.js) que expone `this.$watchModal(getter, closeFn)`
 * para que cualquier componente con un modal "custom" (v-if/v-show, no Bootstrap) se
 * cierre con el botón "atrás" en vez de navegar a la página anterior.
 *
 * Uso típico, en `mounted()`:
 *   this.$watchModal(() => this.miFlagDeModal, () => this.cerrarMiModal());
 *
 * `getter` debe devolver un booleano (o algo truthy/falsy) que indique si el modal
 * está abierto. `closeFn` se invoca únicamente cuando el cierre lo dispara el botón
 * "atrás"; el propio componente sigue siendo responsable de cerrar el modal por sus
 * medios habituales (botón X, click afuera, guardar, etc.).
 */
const registry = new WeakMap();

export default {
    methods: {
        $watchModal(getter, closeFn) {
            const state = { guardId: null };
            const stop = this.$watch(getter, (isOpen) => {
                if (isOpen) {
                    if (state.guardId == null) {
                        state.guardId = pushModalGuard(() => {
                            state.guardId = null;
                            closeFn();
                        });
                    }
                } else if (state.guardId != null) {
                    popModalGuard(state.guardId);
                    state.guardId = null;
                }
            });

            let list = registry.get(this);
            if (!list) {
                list = [];
                registry.set(this, list);
            }
            list.push({ stop, state });
        },
    },
    beforeUnmount() {
        const list = registry.get(this);
        if (!list) return;
        list.forEach(({ stop, state }) => {
            stop();
            if (state.guardId != null) {
                popModalGuard(state.guardId);
                state.guardId = null;
            }
        });
        registry.delete(this);
    },
};
